// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__3f9R1","footer":"Form_footer__3iYO4"};